import React from 'react';
import { useStyles } from './style';

export const IncompleteStatusBanner: React.FC<{ fontSize?: number }> = ({ fontSize }) => {
  const { classes } = useStyles({ fontSize });

  return <div className={classes.incompleteStatusBanner}>Incomplete</div>;
};

export default IncompleteStatusBanner;
